module.exports = __webpack_public_path__ + "static/img/ustanova_dobri_dom_grada_zagreba.b70dd18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/ustanova_dobri_dom_grada_zagreba.png
// module id = 3pDN
// module chunks = 0